import {
  annotationsAppend,
  annotationsBringToFront,
  annotationsCut,
  annotationsDelete,
  annotationsLoaded,
  annotationsMove,
  annotationsMoveBack,
  annotationsMoveForward,
  annotationsPaste,
  annotationsRedo,
  annotationsSendToBack,
  annotationsUndo,
  annotationsUpdate,
  templateApplied,
} from './store/annotations';
import {
  documentIndexChangesApplied,
  documentNotesModified,
  documentNotesSaved,
  documentPageCreated,
  documentPageDeleted,
  documentRemoved,
  documentReplaced,
  documentsLoaded,
  jobReset,
} from './store/documents';
import { jobLoaded } from './store/job';

const ANNOTATION_ACTIONS = [
  annotationsLoaded.type,
  annotationsAppend.type,
  annotationsMove.type,
  annotationsUpdate.type,
  annotationsDelete.type,
  annotationsCut.type,
  annotationsPaste.type,
  annotationsUndo.type,
  annotationsRedo.type,
  annotationsBringToFront.type,
  annotationsSendToBack.type,
  annotationsMoveForward.type,
  annotationsMoveBack.type,
  templateApplied.type,
  jobReset.type,
];

const DOCUMENT_ACTIONS = [
  jobLoaded.type,
  jobReset.type,
  documentsLoaded.type,
  documentRemoved.type,
  documentPageCreated.type,
  documentPageDeleted.type,
  documentReplaced.type,
  documentNotesModified.type,
  documentNotesSaved.type,
  documentIndexChangesApplied.type,
];

export const SYNCHRONIZED_ACTIONS = ([] as readonly string[]).concat(ANNOTATION_ACTIONS).concat(DOCUMENT_ACTIONS);
